function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { onBrightColorValues, onDarkColorValues } from "../../onColorsSettings";
import { _1b1b1bColorValues, ebeff1ColorValues, f7f9fbColorValues, fffColorValues } from "./commonColorValues";
var backgroundColorValues = f7f9fbColorValues;
var backgroundLightColorValues = fffColorValues;
var backgroundDarkerColorValues = _1b1b1bColorValues;
var backgroundDarkColorValues = {
  color: "#343c43",
  onColor: onDarkColorValues
};
var colors = {
  primary: {
    color: "#e20000",
    onColor: onDarkColorValues
  },
  primaryLight: {
    color: "#FD5D5D",
    onColor: onBrightColorValues
  },
  primaryDark: {
    color: "#b00000",
    onColor: onDarkColorValues
  },
  secondary: {
    color: "#1a4079",
    onColor: onDarkColorValues
  },
  secondaryLight: {
    color: "#38B0F6",
    onColor: onBrightColorValues
  },
  secondaryDark: {
    color: "#193052",
    onColor: onDarkColorValues
  },
  success: {
    color: "#007E00",
    onColor: onDarkColorValues
  },
  successLight: {
    color: "#ddf1dd",
    onColor: onBrightColorValues
  },
  error: {
    color: "#C41800",
    onColor: onDarkColorValues
  },
  errorLight: {
    color: "#f8d8cf",
    onColor: onBrightColorValues
  },
  notify: {
    color: "#fff480",
    onColor: onBrightColorValues
  },
  notifyLight: {
    color: "#fff1bf",
    onColor: onBrightColorValues
  },
  disabled: {
    color: "#d2dde5",
    onColor: onBrightColorValues
  },
  dark: _1b1b1bColorValues,
  white: fffColorValues,
  recommend: {
    color: "#c1f1f1",
    onColor: onBrightColorValues
  },
  background: backgroundColorValues,
  backgroundLight: backgroundLightColorValues,
  backgroundLightTint: {
    color: "#e5f0f6",
    onColor: onBrightColorValues
  },
  backgroundDarkLight: ebeff1ColorValues,
  backgroundDark: backgroundDarkColorValues,
  backgroundDarker: backgroundDarkerColorValues,
  backgroundBlack: {
    color: "#000",
    onColor: onDarkColorValues
  },
  backgroundDefaultToLight: _objectSpread(_objectSpread({}, backgroundColorValues), {}, {
    toColor: backgroundLightColorValues.color
  }),
  backgroundLightToDefault: _objectSpread(_objectSpread({}, backgroundColorValues), {}, {
    color: backgroundLightColorValues.color,
    toColor: backgroundColorValues.color
  }),
  backgroundDarkToDarker: _objectSpread(_objectSpread({}, backgroundDarkColorValues), {}, {
    toColor: backgroundDarkerColorValues.color
  }),
  backgroundDarkerToDark: _objectSpread(_objectSpread({}, backgroundDarkColorValues), {}, {
    color: backgroundDarkerColorValues.color,
    toColor: backgroundDarkColorValues.color
  }),
  overlay: {
    color: "rgba(73, 86, 99, 0.6)"
  },
  customDark: {
    color: "#000",
    onColor: onDarkColorValues
  },
  lightBlue: {
    color: "#E5F6FD",
    onColor: onBrightColorValues
  },
  blue: {
    color: "#0076A6",
    onColor: onBrightColorValues
  },
  violet: {
    color: "#692FE1",
    onColor: onDarkColorValues
  },
  violetLight: {
    color: "#D9C7FE",
    onColor: onBrightColorValues
  },
  customLight: fffColorValues
};
export default colors;